import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Provider } from '@angular/core';
import { AppConfigService } from '@elio/emanager-front/shared/app-config';
import { Observable } from 'rxjs';

export class AppInterceptor implements HttpInterceptor {
  private readonly APP_NAME_HTTP_HEADER = 'Elio-App-Name';
  private readonly APP_VERSION_HTTP_HEADER = 'Elio-App-Version';
  private readonly APP_NAME = 'e-lioManager';

  constructor(private appConfigService: AppConfigService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const newRequest = request.clone({
      setHeaders: {
        [this.APP_NAME_HTTP_HEADER]: this.APP_NAME,
        [this.APP_VERSION_HTTP_HEADER]: this.appConfigService.getAppConfig().appVersion,
      },
    });
    return next.handle(newRequest);
  }
}

export const APP_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AppInterceptor,
  deps: [AppConfigService],
  multi: true,
};
